var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69234 3.14387L8.51547 2.32074C8.94313 1.89309 9.63649 1.89309 10.0642 2.32074L11.6128 3.86943C12.0405 4.29708 12.0405 4.99045 11.6128 5.41811L5.41811 11.6128C4.99045 12.0405 4.29708 12.0405 3.86942 11.6128L2.32074 10.0642C1.89309 9.6365 1.89309 8.94313 2.32074 8.51548L3.14387 7.69234C2.64784 6.85247 2.76063 5.75256 3.48225 5.03094L5.03094 3.48226C5.75256 2.76063 6.85246 2.64784 7.69234 3.14387Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3077 20.8561L15.4845 21.6793C15.0569 22.1069 14.3635 22.1069 13.9358 21.6793L12.3872 20.1306C11.9595 19.7029 11.9595 19.0095 12.3872 18.5819L18.5819 12.3872C19.0096 11.9595 19.7029 11.9595 20.1306 12.3872L21.6793 13.9358C22.1069 14.3635 22.1069 15.0569 21.6793 15.4845L20.8561 16.3077C21.3522 17.1475 21.2394 18.2474 20.5177 18.9691L18.9691 20.5177C18.2474 21.2394 17.1475 21.3522 16.3077 20.8561Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2257 8.12824L8.1283 11.2256L12.7744 15.8717L15.8717 12.7743L11.2257 8.12824Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbell);
export default __webpack_public_path__ + "static/media/dumbell.d46f13eab03ed988a8e671082e7bb816.svg";
export { ForwardRef as ReactComponent };